import type { ComponentProps } from "react";

/**
 * Silhouette placeholder at the mock's proportions until the mascot art is
 * dropped into assets/mascot (see manifest.ts). Tints with currentColor.
 */
export function PlaceholderSilhouette(props: ComponentProps<"svg">) {
  return (
    <svg viewBox="0 0 105 113" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M52 8c-9 0-15 5-19 12l-11-9c-3-2-7 0-6 4l3 17c-7 8-10 18-10 29 0 26 19 44 43 44s43-18 43-44c0-11-3-21-10-29l3-17c1-4-3-6-6-4l-11 9c-4-7-10-12-19-12z" />
      <path d="M78 60c8-4 20-2 24 8-6 6-18 5-24-8z" opacity="0.8" />
      <circle cx="40" cy="50" r="5" fill="var(--content)" />
      <circle cx="64" cy="50" r="5" fill="var(--content)" />
    </svg>
  );
}
